import type { ReactElement } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

interface IHeaderProps {
  isOpen: boolean;
}

export const AppliedInvoiceHeader = ({
  isOpen
}: IHeaderProps): ReactElement => {
  const isMobile = useMediaQuery('xl');
  const { data: cart } = useAppSelector((state) => state.cart);

  const companyDocumentNumber =
    cart?.billingAddress?.companyIdentityDocumentNumber;

  return (
    <div
      className={`
                  co-w-full co-flex co-items-center co-gap-8px co-content-between
                  co-overflow-hidden co-select-none co-cursor-pointer co-flex-wrap co-h-auto co-relative co-rounded-lg
                  ${isOpen && 'co-rounded-b-none'}
              `}
    >
      <div className="co-flex co-w-full co-gap-8px co-cursor-pointer co-justify-between">
        {isMobile ? (
          <div className="co-flex co-flex-col co-w-full co-min-w-0">
            <div className="co-flex co-justify-between">
              <div className="co-flex co-items-center co-gap-x-1">
                <Icon icon="ReceiptIcon" width={18} height={20} />
                <Typography weight="semibold">Datos de facturación</Typography>
              </div>
              <div className="co-flex co-justify-end co-items-center co-gap-4">
                <Nav isOpen={isOpen} />
              </div>
            </div>
            <Subtitle isOpen={isOpen} />
          </div>
        ) : (
          <div
            className={`co-flex co-w-full ${
              isOpen ? 'co-flex-col co-gap-y-3' : ''
            }`}
          >
            <div className="co-flex co-w-full co-min-w-0 co-gap-x-4">
              <div className="co-flex co-items-center co-gap-x-1 co-whitespace-nowrap">
                <Icon icon="ReceiptIcon" width={18} height={20} />
                <Typography weight="semibold">Datos de facturación</Typography>
              </div>
              {isOpen ? (
                <div className="co-w-full" />
              ) : (
                <div className="co-flex co-w-full co-justify-end co-min-w-0 co-gap-x-4">
                  <Subtitle isOpen={isOpen} />
                  <span>|</span>
                  <div className="co-whitespace-nowrap">
                    <Typography>RUT: {companyDocumentNumber}</Typography>
                  </div>
                </div>
              )}
              <div className="co-flex co-items-center co-gap-x-4">
                <Nav isOpen={isOpen} />
              </div>
            </div>
            {isOpen ? <Subtitle isOpen={isOpen} /> : null}
          </div>
        )}
      </div>
    </div>
  );
};

const Nav = ({ isOpen }: IHeaderProps) => (
  <Icon color="black" icon={isOpen ? 'NewArrowDownIcon' : 'NewArrowUpIcon'} />
);

const Subtitle = ({ isOpen }: IHeaderProps) => {
  const { data: cart } = useAppSelector((state) => state.cart);

  const subtitleAttributes = isOpen
    ? ''
    : { className: 'co-truncate', noWrap: true };

  return (
    <Typography {...subtitleAttributes}>
      {cart?.billingAddress?.companyBusinessName}
    </Typography>
  );
};
